<template>
	<div class="container">
		<div class="row">
			<div class="form-container recover-password-form">
				<h2 class="title-center header-no-padding-bottom">Cambiar contraseña</h2>
				<div class="col-sm-6 col-sm-offset-3">
					<form class="form-horizontal" role="form" novalidate @submit="resetPassword">
						<div class="form-group">
							<label class="control-label col-sm-3" for="password">Nueva contraseña</label>
							<div class="col-sm-9"> 
							    <input type="password" class="form-control" :class="{ 'has-error': err.password }" id="password" v-model="form.password">
							    <div class="tooltip-error" v-if="err.password">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa tu contraseña para continuar.
					      		</div>
							</div>
						</div>
						<div class="form-group">
							<label class="control-label col-sm-3" for="password2">Confirmar Nueva Contraseña</label>
							<div class="col-sm-9"> 
							    <input type="password" class="form-control" :class="{ 'has-error': err.password2 }" id="password2" v-model="form.password2">
							    <div class="tooltip-error" v-if="err.password2">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa tu contraseña para continuar.
					      		</div>
					      		<div class="tooltip-error" v-if="err.password3">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Las contraseñas no coinciden.
					      		</div>
							</div>
						</div>
						<div class="form-group"> 
						    <div class="col-sm-offset-3 col-sm-9">
						      <button type="submit" class="btn btn-black btn-lg">Cambiar contraseña</button>
						    </div>
					    </div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import API from '../store/api';

var form = {
	password: '',
	password2: ''
};

export default {
	// ---- DATA ----

	data() {
		return {
			form: form,
			has_error: false,
			error_msg: '',
			err: {}
		};
	},

	// ---- METHODS ----

	methods: {
		resetPassword(e) {
			e.preventDefault();
			this.has_error = false;
			this.error_msg = '';
			this.err = {};

			this.validatePassword();

			$(window).resize( function(){
				if ($(window).width()<778){
					setTimeout( function(){
						$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
						$(".top-caret").css({"display": "none"});
						$(".tooltip-error").addClass("center-block");
					}, 10);
				}else{
					setTimeout( function(){
						$(".tooltip-error").css({"position": "absolute", "margin-top" : "0"});
						$(".top-caret").css({"display": "block"});
						$(".tooltip-error").addClass("center-block");
					}, 10);
				}
			});

			if (this.has_error) {
				return;
			}

			this.form.verification_token = this.$route.params.token;

			API.Users.resetPass(this.form);
		},

		validatePassword() {
			for (var k in this.form) {
				if (!this.form[k]) {
					this.has_error = true;
					this.err[k] = true;
				}
			}

			if (this.form.password !== this.form.password2) {
				this.err.password2 = true;
				this.has_error = true;
				this.error_msg = 'Tus contraseñas no coinciden.'
			}

			if (this.form.password.length < 8) {
				this.error_msg = 'Tu contraseña debe tener al menos 8 caracteres.';
			}

			if (!this.form.password || !this.form.password2) {
				this.error_msg = 'Ingresa tu contraseña';
			}
		},

		isLogin() {
			let user = JSON.parse(localStorage.getItem('lasddi')) || {};
			// Check if the user is logged, and redirect to admin users.
			if (user.api_token) {
				router.go('/home');
			}
		}
	},

	// ---- READY ----

	ready() {
		this.isLogin();
		$('#email').focus();
	}
}
</script>


// WEBPACK FOOTER //
// Recover-password.vue?1ef07b74